import { render } from "./AnalyticsNotesTradeTabSwitcher.vue?vue&type=template&id=6784e1fe&scoped=true&ts=true"
import script from "./AnalyticsNotesTradeTabSwitcher.vue?vue&type=script&lang=ts"
export * from "./AnalyticsNotesTradeTabSwitcher.vue?vue&type=script&lang=ts"

import "./AnalyticsNotesTradeTabSwitcher.vue?vue&type=style&index=0&id=6784e1fe&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6784e1fe"]])

export default __exports__